import type { RolePayload } from '@Application/Security/Roles/Actions/rolesFetched';

export type RoleCreatedPayload = RolePayload;

export type RoleCreatedAction = {
	type: 'ROLE_CREATED';
	payload: RoleCreatedPayload;
	accountId: number;
};

export default (payload: RoleCreatedPayload, accountId: number): RoleCreatedAction => ({
	type: 'ROLE_CREATED',
	payload,
	accountId,
});
